(() => {
  if (window.__rvSocialShareInitialized) return;
  window.__rvSocialShareInitialized = true;

  const init = () => {
    const articleContent = document.querySelector('.article-template__content');
    const topShare = document.querySelector('.rv-social-share--top');

    if (articleContent && topShare && !articleContent.contains(topShare)) {
      const paragraphs = Array.from(articleContent.children).filter((el) => el.tagName === 'P');
      const target = paragraphs[1] || paragraphs[0];

      if (target) {
        const oldWrapper = topShare.closest('.article-template__social-sharing');
        target.insertAdjacentElement('afterend', topShare);
        if (oldWrapper && !oldWrapper.children.length) oldWrapper.remove();
      }
    }

    document.querySelectorAll('.rv-social-share__copy').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.dataset.shareUrl;
        const label = button.querySelector('.rv-social-share__copy-label');
        const original = label ? label.textContent : 'Copy Link';

        try {
          await navigator.clipboard.writeText(url);
          button.classList.add('is-copied');
          if (label) label.textContent = 'Copied!';
          window.setTimeout(() => {
            button.classList.remove('is-copied');
            if (label) label.textContent = original;
          }, 1800);
        } catch (error) {
          window.prompt('Copy this link:', url);
        }
      });
    });

    document.querySelectorAll('.rv-social-share__native').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.dataset.shareUrl;
        const title = button.dataset.shareTitle || document.title;

        if (navigator.share) {
          try {
            await navigator.share({ title, url });
            return;
          } catch (error) {
            if (error && error.name === 'AbortError') return;
          }
        }

        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          window.prompt('Copy this link:', url);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
